import styled from "styled-components";

export const StyledMain = styled.main`
  min-height: calc(100vh - 50px);
  display: flex;
  justify-content: center;
  background-color: rgb(250, 250, 255);
  padding-bottom: 40px;
`;